<template>
<div>

    <el-crud :baseUrl="'/laboragreements'" 
        v-model="resource"
        :actions="['edit','delete']"
        :config="crudConfig"
        ref="crud">

        <template slot="table">
            <el-table-column type="expand">
                <template slot-scope="scope">
                    <table class="details">
                        <tr>
                            <td><strong>Hora normal</strong></td>
                            <td>{{scope.row.definition.working_time.code}}</td>
                        </tr>
                        <tr>
                            <td><strong>Recargo Nocturno</strong></td>
                            <td>{{scope.row.definition.night_surcharge.code}}</td>
                        </tr>
                        <tr>
                            <td><strong>Hora Extra</strong></td>
                            <td>{{scope.row.definition.overtime.code}}</td>
                        </tr>
                        <tr>
                            <td><strong>Hora Extra Nocturna</strong></td>
                            <td>{{scope.row.definition.night_overtime.code}}</td>
                        </tr>
                        <tr>
                            <td><strong>Recargo Dominical</strong></td>
                            <td>{{scope.row.definition.sunday_surcharge.code}}</td>
                        </tr>
                        <tr>
                            <td><strong>Recargo Dominical Nocturno</strong></td>
                            <td>{{scope.row.definition.sunday_night_surcharge.code}}</td>
                        </tr>
                        <tr>
                            <td><strong>Recargo Dominical (Compensado)</strong></td>
                            <td>{{scope.row.definition.sunday_surcharge_comp.code}}</td>
                        </tr>
                        <tr>
                            <td><strong>Recargo Dominical Nocturno (Compensado)</strong></td>
                            <td>{{scope.row.definition.sunday_night_surcharge_comp.code}}</td>
                        </tr>
                        <tr>
                            <td><strong>Hora Extra Dominical</strong></td>
                            <td>{{scope.row.definition.sunday_overtime.code}}</td>
                        </tr>
                        <tr>
                            <td><strong>Hora Extra Dominical Nocturna</strong></td>
                            <td>{{scope.row.definition.sunday_night_overtime.code}}</td>
                        </tr>
                        <tr>
                            <td><strong>Recargo Festivo</strong></td>
                            <td>{{scope.row.definition.holiday_surcharge.code}}</td>
                        </tr>
                        <tr>
                            <td><strong>Recargo Festivo Nocturno</strong></td>
                            <td>{{scope.row.definition.holiday_night_surcharge.code}}</td>
                        </tr>
                        <tr>
                            <td><strong>Recargo Festivo (Compensado)</strong></td>
                            <td>{{scope.row.definition.holiday_surcharge_comp.code}}</td>
                        </tr>
                        <tr>
                            <td><strong>Recargo Festivo Nocturno (Compensado)</strong></td>
                            <td>{{scope.row.definition.holiday_night_surcharge_comp.code}}</td>
                        </tr>
                        <tr>
                            <td><strong>Hora Extra Festiva</strong></td>
                            <td>{{scope.row.definition.holiday_overtime.code}}</td>
                        </tr>
                        <tr>
                            <td><strong>Hora Extra Festiva Nocturna</strong></td>
                            <td>{{scope.row.definition.holiday_night_overtime.code}}</td>
                        </tr>
                        <tr>
                            <td><strong>Amanecidas</strong></td>
                            <td>{{scope.row.definition.worked_overtime_until_dawn.code}}</td>
                        </tr>
                        <tr>
                            <td><strong>Llegada tarde</strong></td>
                            <td>{{scope.row.definition.late_check_in.code}}</td>
                        </tr>
                    </table>
                </template>
            </el-table-column>
            <el-table-column
                prop="company_id_number"
                align="right"
                width="80px"
                label="Código">
            </el-table-column>
            <el-table-column
                prop="description"
                label="Descripción">
            </el-table-column>
            <el-table-column
                prop="definition.hours_per_week"
                align="right"
                label="Horas x semana">
            </el-table-column>
            <el-table-column
                prop="definition.hours_per_day"
                align="right"
                label="Horas x día">
            </el-table-column>
            <el-table-column
                align="right"
                label="Permite Horas Extra">
                <template slot-scope="scope">
                    {{allowOvertimeLabel(scope.row.definition.allow_overtime)}}
                </template>
            </el-table-column>
        </template>

        <template slot="form" slot-scope="scope">
            <el-form-item label="Código" label-width="240px" :prop="resource.company_id_number" :error="scope.errors.company_id_number">
                <el-input v-model="resource.company_id_number" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Descripción" label-width="240px" :prop="resource.description" :error="scope.errors.description">
                <el-input v-model="resource.description" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Horas semanales" label-width="240px" :prop="resource.definition.value.hours_per_week">
                <el-input v-model="resource.definition.value.hours_per_week" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Horas diarias" label-width="240px" :prop="resource.definition.value.hours_per_day">
                <el-input v-model="resource.definition.value.hours_per_day" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Permite horas extra" label-width="240px" :prop="resource.definition.value.allow_overtime">
                <el-select v-model="resource.definition.value.allow_overtime" filterable placeholder="Seleccione" size="mini">
                    <el-option
                        v-for="item in allow_overtime_options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="Hora normal" label-width="240px" :prop="resource.definition.value.working_time_code">
                <el-input v-model="resource.definition.value.working_time_code" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Recargo Nocturno" label-width="240px" :prop="resource.definition.value.night_surcharge_code">
                <el-input v-model="resource.definition.value.night_surcharge_code" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Hora Extra" label-width="240px" :prop="resource.definition.value.overtime_code">
                <el-input v-model="resource.definition.value.overtime_code" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Hora Extra Nocturna" label-width="240px" :prop="resource.definition.value.night_overtime_code">
                <el-input v-model="resource.definition.value.night_overtime_code" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Recargo Dominical" label-width="240px" :prop="resource.definition.value.sunday_surcharge_code">
                <el-input v-model="resource.definition.value.sunday_surcharge_code" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Recargo Dominical Nocturno" label-width="240px" :prop="resource.definition.value.sunday_night_surcharge_code">
                <el-input v-model="resource.definition.value.sunday_night_surcharge_code" auto-complete="off" size="mini"></el-input>
            </el-form-item>

            <el-form-item label="Recargo Dominical (Compensado)" label-width="240px" :prop="resource.definition.value.sunday_surcharge_comp_code">
                <el-input v-model="resource.definition.value.sunday_surcharge_comp_code" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Recargo Dominical Nocturno (Compensado)" label-width="240px" :prop="resource.definition.value.sunday_night_surcharge_comp_code">
                <el-input v-model="resource.definition.value.sunday_night_surcharge_comp_code" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Hora Extra Dominical" label-width="240px" :prop="resource.definition.value.sunday_overtime_code">
                <el-input v-model="resource.definition.value.sunday_overtime_code" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Hora Extra Dominical Nocturna" label-width="240px" :prop="resource.definition.value.sunday_night_overtime_code">
                <el-input v-model="resource.definition.value.sunday_night_overtime_code" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Recargo Festivo" label-width="240px" :prop="resource.definition.value.holiday_surcharge_code">
                <el-input v-model="resource.definition.value.holiday_surcharge_code" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Recargo Festivo Nocturno" label-width="240px" :prop="resource.definition.value.holiday_night_surcharge_code">
                <el-input v-model="resource.definition.value.holiday_night_surcharge_code" auto-complete="off" size="mini"></el-input>
            </el-form-item>

            <el-form-item label="Recargo Festivo (Compensado)" label-width="240px" :prop="resource.definition.value.holiday_surcharge_comp_code">
                <el-input v-model="resource.definition.value.holiday_surcharge_comp_code" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Recargo Festivo Nocturno (Compensado)" label-width="240px" :prop="resource.definition.value.holiday_night_surcharge_comp_code">
                <el-input v-model="resource.definition.value.holiday_night_surcharge_comp_code" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Hora Extra Festiva" label-width="240px" :prop="resource.definition.value.holiday_overtime_code">
                <el-input v-model="resource.definition.value.holiday_overtime_code" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Hora Extra Festiva Nocturna" label-width="240px" :prop="resource.definition.value.holiday_night_overtime_code">
                <el-input v-model="resource.definition.value.holiday_night_overtime_code" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Amanecidas" label-width="240px" :prop="resource.definition.value.worked_overtime_until_dawn_code">
                <el-input v-model="resource.definition.value.worked_overtime_until_dawn_code" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Llegada tarde" label-width="240px" :prop="resource.definition.value.late_check_in_code">
                <el-input v-model="resource.definition.value.late_check_in_code" auto-complete="off" size="mini"></el-input>
            </el-form-item>
        </template>
    </el-crud>

</div>
</template>

<style>
table.details td {
    padding-left: 3px;
    padding-right: 3px;
    font-size: 11px;
    line-height: 1.3em;
    height: 15px;
}
</style>

<script>
    import el_crud from '../el-crud.vue';
    export default {
        data() {
            return {
                crudConfig:{
                    AddItemTitle: 'Nuevo Acuerdo',
                    EditItemTitle: 'Editar Acuerdo',
                    DeleteItemConfirmMessage: 'Esto borrará permanentemente el acuerdo laboral. Desea continuar?'
                },
                allow_overtime_options: [
                    {label: 'No', value: 'NO'},
                    {label: 'Libre', value: 'FREE'},
                    {label: 'Con autorización', value: 'AUTHORIZED'}
                ],
                resource:{
                    description: null,
                    company_id_number: null,
                    definition: {
                        value: {
                            allow_overtime: null,
                            working_time_code: null,
                            night_surcharge_code: null,
                            overtime_code: null,
                            night_overtime_code: null,
                            sunday_surcharge_code: null,
                            sunday_night_surcharge_code: null,
                            sunday_surcharge_comp_code: null,
                            sunday_night_surcharge_comp_code: null,
                            sunday_overtime_code: null,
                            sunday_night_overtime_code: null,
                            holiday_surcharge_code: null,
                            holiday_night_surcharge_code: null,
                            holiday_surcharge_comp_code: null,
                            holiday_night_surcharge_comp_code: null,
                            holiday_overtime_code: null,
                            holiday_night_overtime_code: null,
                            worked_overtime_until_dawn_code: null,
                            late_check_in_code: null,
                            hours_per_week: null,
                            hours_per_day: null,
                        },
                        setValue: (value) => {
                            // console.log(value);

                            if (value == null) {
                                this.resource.definition.value.allow_overtime = null;

                                this.resource.definition.value.working_time_code = null;
                                this.resource.definition.value.night_surcharge_code = null;
                                this.resource.definition.value.overtime_code = null;
                                this.resource.definition.value.night_overtime_code = null;
                                this.resource.definition.value.sunday_surcharge_code = null;
                                this.resource.definition.value.sunday_night_surcharge_code = null;

                                this.resource.definition.value.sunday_surcharge_comp_code = null;
                                this.resource.definition.value.sunday_night_surcharge_comp_code = null;
                                this.resource.definition.value.sunday_overtime_code = null;
                                this.resource.definition.value.sunday_night_overtime_code = null;
                                this.resource.definition.value.holiday_surcharge_code = null;
                                this.resource.definition.value.holiday_night_surcharge_code = null;

                                this.resource.definition.value.holiday_surcharge_comp_code = null;
                                this.resource.definition.value.holiday_night_surcharge_comp_code = null;
                                this.resource.definition.value.holiday_overtime_code = null;
                                this.resource.definition.value.holiday_night_overtime_code = null;

                                this.resource.definition.value.worked_overtime_until_dawn_code = null;

                                this.resource.definition.value.late_check_in_code = null;

                                this.resource.definition.value.hours_per_week = null;
                                this.resource.definition.value.hours_per_day = null;

                            } else {
                                this.resource.definition.value.allow_overtime = value.definition.allow_overtime;

                                this.resource.definition.value.working_time_code = value.definition.working_time.code;
                                this.resource.definition.value.night_surcharge_code = value.definition.night_surcharge.code;
                                this.resource.definition.value.overtime_code = value.definition.overtime.code;
                                this.resource.definition.value.night_overtime_code = value.definition.night_overtime.code;
                                this.resource.definition.value.sunday_surcharge_code = value.definition.sunday_surcharge.code;
                                this.resource.definition.value.sunday_night_surcharge_code = value.definition.sunday_night_surcharge.code;

                                this.resource.definition.value.sunday_surcharge_comp_code = value.definition.sunday_surcharge_comp.code;
                                this.resource.definition.value.sunday_night_surcharge_comp_code = value.definition.sunday_night_surcharge_comp.code;
                                this.resource.definition.value.sunday_overtime_code = value.definition.sunday_overtime.code;
                                this.resource.definition.value.sunday_night_overtime_code = value.definition.sunday_night_overtime.code;
                                this.resource.definition.value.holiday_surcharge_code = value.definition.holiday_surcharge.code;
                                this.resource.definition.value.holiday_night_surcharge_code = value.definition.holiday_night_surcharge.code;

                                this.resource.definition.value.holiday_surcharge_comp_code = value.definition.holiday_surcharge_comp.code;
                                this.resource.definition.value.holiday_night_surcharge_comp_code = value.definition.holiday_night_surcharge_comp.code;
                                this.resource.definition.value.holiday_overtime_code = value.definition.holiday_overtime.code;
                                this.resource.definition.value.holiday_night_overtime_code = value.definition.holiday_night_overtime.code;

                                this.resource.definition.value.worked_overtime_until_dawn_code = value.definition.worked_overtime_until_dawn.code;

                                this.resource.definition.value.late_check_in_code = value.definition.late_check_in.code;

                                this.resource.definition.value.hours_per_week = value.definition.hours_per_week;
                                this.resource.definition.value.hours_per_day = value.definition.hours_per_day;
                            }

                        },
                    }
                },
            };
        },
        components: {
            'el-crud': el_crud,
        },
        methods: {
            allowOvertimeLabel(value) {
                for (let i in this.allow_overtime_options) {
                    if (this.allow_overtime_options[i].value == value) {
                        return this.allow_overtime_options[i].label;
                    }
                }
                return null;
            }
        }
    }
</script>
